$(document).ready(function () {
   $('.site-header__search-toggle').on('click', function() {
        $('html').addClass('js-drawer-open js-drawer-open-top');
        $('#SearchDrawer').show(); // Show the search drawer
    });

    // Close the search drawer when the close icon is clicked
    $('.search-bar__close').on('click', function() {
        $('html').removeClass('js-drawer-open js-drawer-open-top');
        $('#SearchDrawer').hide(); // Hide the search drawer
    });
 
    const toggleBtn = document.querySelector(".js-mobile-nav-toggle");
    const nav = document.querySelector("nav.mobile-nav-wrapper.medium-up--hide");

    toggleBtn.addEventListener("click", function () {
      // Toggle open/close class on button
      if (toggleBtn.classList.contains("mobile-nav--open")) {
        toggleBtn.classList.remove("mobile-nav--open");
        toggleBtn.classList.add("mobile-nav--close");
      } else {
        toggleBtn.classList.remove("mobile-nav--close");
        toggleBtn.classList.add("mobile-nav--open");
      }

      // Toggle nav class
      nav.classList.toggle("js-menu--is-open");
    });



  $(".tab-header").click(function () {
    const $tab = $(this).closest(".collapsible-tab");
    const $content = $tab.find(".tab-content");
    const $icon = $tab.find(".tab-icon");

    // Toggle content visibility
    $content.slideToggle(200);

    // Toggle icon
    if ($icon.text() === "+") {
      $icon.text("−");
    } else {
      $icon.text("+");
    }
  });


  document.querySelectorAll('[id^="countdown-section-"]').forEach(function (section) {
    const timerEl = section.querySelector('[id^="timer-"]');
    if (!timerEl) return;

    const startTime = new Date(section.dataset.startTime).getTime();
    const endTime = new Date(section.dataset.endTime).getTime();

    function updateCountdown() {
      const now = new Date().getTime();

      if (now < startTime) {
        timerEl.innerHTML = "Sale will start soon!";
        return;
      }

      const distance = endTime - now;

      if (distance < 0) {
        timerEl.innerHTML = "Sale ended";
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      timerEl.innerHTML =
        `<div class="timer-unit"><div class="number">${days}</div><div class="label">Days</div></div>
         <div class="timer-unit"><div class="number">${hours}</div><div class="label">Hours</div></div>
         <div class="timer-unit"><div class="number">${minutes}</div><div class="label">Minutes</div></div>
         <div class="timer-unit"><div class="number">${seconds}</div><div class="label">Seconds</div></div>`;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });



});
